import { request } from './request'

// 等待转化接口
export function change() {
  // debugger
  return request({
    url: '',
    data: {
        
    }
  })
}
